export const GET_CATEGORIES_REQUEST = "GET_CATEGORIES_REQUEST";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_ERROR = "GET_CATEGORIES_ERROR";
export const GET_CATEGORIES_DONE = "GET_CATEGORIES_DONE";

export const GET_CATEGORY_VIDEOS_REQUEST = "GET_CATEGORY_VIDEOS_REQUEST";
export const GET_CATEGORY_VIDEOS_SUCCESS = "GET_CATEGORY_VIDEOS_SUCCESS";
export const GET_CATEGORY_VIDEOS_ERROR = "GET_CATEGORY_VIDEOS_ERROR";

export const getCategoriesRequest = (payload) => ({
  type: GET_CATEGORIES_REQUEST,
  ...payload,
});

export const getCategoriesSuccess = (categories) => ({
  type: GET_CATEGORIES_SUCCESS,
  categories,
});

export const getCategoriesError = (error) => ({
  type: GET_CATEGORIES_ERROR,
  error,
});

export const getCategoriesDone = () => ({
  type: GET_CATEGORIES_DONE,
});

export const getCategoryVideosRequest = (payload) => ({
  type: GET_CATEGORY_VIDEOS_REQUEST,
  ...payload,
});

export const getCategoryVideosSuccess = (videos) => ({
  type: GET_CATEGORY_VIDEOS_SUCCESS,
  videos,
});

export const getCategoryVideosError = (error) => ({
  type: GET_CATEGORY_VIDEOS_ERROR,
  error,
});



// WEBPACK FOOTER //
// ./src/pages/playlists/form/videos/video-chooser/actions.js